import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { cn } from '../lib/utils';

/**
 * Reusable info "?" icon. Click to open a small popover with rich content.
 * Use whenever introducing a new concept the user might not understand.
 *
 * <InfoTooltip title="Organization Files" testId="info-firm">
 *   <p>Shared across your team…</p>
 * </InfoTooltip>
 */
export default function InfoTooltip({
  title,
  children,
  className,
  iconClassName,
  testId,
  align = 'start',
  side = 'top',
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={title ? `What is ${title}?` : 'More info'}
          data-testid={testId}
          className={cn(
            'inline-flex items-center justify-center rounded-full p-0.5 text-muted-foreground/70 hover:text-primary hover:bg-primary/10 transition-colors',
            className,
          )}
        >
          <Info className={cn('w-3.5 h-3.5', iconClassName)} />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} align={align} className="w-80 text-sm leading-relaxed">
        {title && <div className="font-semibold mb-1.5">{title}</div>}
        <div className="text-muted-foreground space-y-1.5">{children}</div>
      </PopoverContent>
    </Popover>
  );
}
